import type { DynamicClient } from '../../../../client/types';
import { getNetworksData } from '../getNetworksData';
import type { NetworkProvider } from '../networkProvider';
import { getNetworkProviderBuilderRegistry } from '../networkProviderBuilderRegistry';

/**
 * Retrieves all registered network providers for enabled chains.
 */
export const getNetworkProviders = (
  client: DynamicClient
): NetworkProvider[] => {
  const networkProviderBuilderRegistry =
    getNetworkProviderBuilderRegistry(client);

  const registeredNetworkProviderBuilders = Array.from(
    networkProviderBuilderRegistry.get().values()
  );

  const networksData = getNetworksData(client);

  const networkProviders = registeredNetworkProviderBuilders.map(
    ({ builder, chain }) => {
      const networksDataForChain = networksData.filter(
        (networkData) => networkData.chain === chain
      );

      return networksDataForChain.map(builder);
    }
  );

  return networkProviders.flat();
};
